(function ($) {

    // ====== Fresh-nonce AJAX helper ======
    // Fetches the cart nonce on demand from a non-cacheable REST route so page
    // cache can never serve a stale nonce baked into the HTML (which produced a
    // 403 from check_ajax_referer for logged-out visitors on cached pages).
    const NONCE_ENDPOINT = '/wp-json/dnnz/v1/nonce';
    let cachedNonce = null;
    let inflightNonce = null;

    function fetchNonce() {
        return fetch(NONCE_ENDPOINT, {
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
        }).then(function (res) {
            if (!res.ok) throw new Error('Nonce fetch failed: ' + res.status);
            return res.json();
        }).then(function (data) {
            if (!data || typeof data.nonce !== 'string') throw new Error('Nonce response malformed');
            return data.nonce;
        });
    }

    function getNonce() {
        if (cachedNonce) return Promise.resolve(cachedNonce);
        if (inflightNonce) return inflightNonce;
        inflightNonce = fetchNonce().then(function (nonce) {
            cachedNonce = nonce;
            return nonce;
        }).finally(function () {
            inflightNonce = null;
        });
        return inflightNonce;
    }

    // POST to admin-ajax. Fast path: use the nonce baked into the page (busted per
    // deploy via the theme version), so the happy path costs zero extra requests.
    // Only on a 403 — a stale baked nonce, e.g. a page-cache TTL longer than the
    // nonce lifetime — fetch a fresh one from the non-cacheable endpoint and retry
    // once. Falls back to the endpoint up front only if no nonce was localized.
    function dnnzAjax(action, payload) {
        const ajaxUrl = offer40_data.ajax_url;
        const buildBody = function (nonce) {
            const body = new URLSearchParams();
            Object.keys(payload || {}).forEach(function (key) {
                body.append(key, String(payload[key]));
            });
            body.set('action', action);
            body.set('security', nonce);
            return body;
        };
        const post = function (nonce) {
            return fetch(ajaxUrl, { method: 'POST', credentials: 'same-origin', body: buildBody(nonce) });
        };
        const baked = (offer40_data && typeof offer40_data.nonce === 'string') ? offer40_data.nonce : null;
        // Prefer an already-fetched fresh nonce, then the baked-in one; hit the
        // endpoint up front only when neither exists.
        const firstNonce = cachedNonce || baked;
        const firstAttempt = firstNonce ? post(firstNonce) : getNonce().then(post);
        return firstAttempt.then(function (response) {
            if (response.status !== 403) return response;
            cachedNonce = null;
            return getNonce().then(post);
        });
    }

    function getMonthsWord(months) {
        const m = parseInt(months);
        if (m === 1) return 'miesiąc';
        if (m >= 2 && m <= 4) return 'miesiące';
        return 'miesięcy';
    }

    function formatPrice(price) {
        const p = Number.isInteger(price) ? price : price.toFixed(2);
        return p.toString().replace('.', ',').replace(',00', '');
    }

    const $block = $('.offer-40');
    if (!$block.length) return;

    const cartUrl = $block.data('cart-url');
    const showPricesPerMonth = $block.data('show-prices-per-month');
    const showPromoPrices = $block.data('show-promo-prices');
    const showReferencePrice = $block.data('show-reference-price');
    const trainingProductId = $block.data('training-product-id');

    // ====== DURATION SELECTOR ======
    $block.find('.offer-40__select.variant li').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');

        const variantIdx = $(this).data('variant');
        const actualVariantLength = parseInt($(this).data('variant-length'));
        const variantLength = showPricesPerMonth ? actualVariantLength : 1;

        $block.find('.offer-40__column').each(function () {
            updateColumnPrices($(this), variantIdx, variantLength, actualVariantLength);
            updatePropertyVisibility($(this), variantIdx);
        });

        // Update variant description text.
        const $infoText = $block.find('.offer-40__info-text');
        if ($infoText.length) {
            const descriptions = $infoText.data('descriptions');
            if (descriptions && descriptions[variantIdx] !== undefined) {
                $infoText.html(descriptions[variantIdx]);
            }
        }

        updateGlobalSavingsVisibility();
        equalizeColumnHeights();
    });

    // ====== PACKAGE SELECTOR (mobile) ======
    $block.find('.offer-40__select.package li').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        const packageId = $(this).data('packageId');

        // Check if current column-top is stuck before switching.
        const wasSticky = $block.find('.offer-40__column-top.is-sticky').length > 0;

        $block.find('.offer-40__column-top').removeClass('is-sticky');
        $block.find('.offer-40__sticky-boundary').css('min-height', '');

        $block.find('.offer-40__column').each(function () {
            if ($(this).data('package') === packageId - 1) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });

        // If was sticky, immediately apply is-sticky to new column.
        if (wasSticky) {
            const $newColumn = $block.find('.offer-40__column.active');
            const $newColumnTop = $newColumn.find('.offer-40__column-top');
            const $newIcons = $newColumn.find('.offer-40__package-icons');
            const $newBoundary = $newColumnTop.closest('.offer-40__sticky-boundary');

            // Clear inline styles from when this column was inactive, then re-hide instantly.
            $newIcons.css({ transition: '', maxHeight: '', opacity: '', margin: '', padding: '', overflow: '' });
            $newIcons[0].offsetHeight; // Force reflow.
            $newIcons.css({ transition: 'none', maxHeight: 0, opacity: 0, margin: 0, padding: 0, overflow: 'hidden' });

            $newBoundary.css('min-height', $newBoundary.outerHeight());
            $newColumnTop.addClass('is-sticky');

            // Restore transition so next unsticky animates smoothly.
            requestAnimationFrame(() => {
                $newIcons.css('transition', '');
            });
        }
    });

    // ====== PAYMENT TYPE RADIO ======
    $block.on('change', 'input[name^="payment_type_"]', function () {
        const $column = $(this).closest('.offer-40__column');

        // Toggle active class on payment options.
        $column.find('.payment-option').removeClass('active');
        $(this).closest('.payment-option').addClass('active');

        // Get current variant selection.
        const $activeVariant = $block.find('.offer-40__select.variant li.active');
        const variantIdx = $activeVariant.data('variant');
        const actualVariantLength = parseInt($activeVariant.data('variant-length'));
        const variantLength = showPricesPerMonth ? actualVariantLength : 1;

        updateColumnPrices($column, variantIdx, variantLength, actualVariantLength);
        updateCTALink($column, variantIdx);
    });

    // ====== TRAINING TOGGLE ======
    $block.on('change', '.training-toggle-input', function () {
        const $column = $(this).closest('.offer-40__column');
        const $activeVariant = $block.find('.offer-40__select.variant li.active');
        const variantIdx = $activeVariant.data('variant');
        updateCTALink($column, variantIdx);
    });

    // ====== CORE UPDATE FUNCTIONS ======

    function getActiveVariants($column) {
        const paymentType = $column.find('input[name^="payment_type_"]:checked').val();
        return (paymentType === 'subscription')
            ? $column.data('subscription-variants')
            : $column.data('onetime-variants');
    }

    function updateColumnPrices($column, variantIdx, variantLength, actualVariantLength) {
        const variants = getActiveVariants($column);
        if (!variants || !variants[variantIdx]) return;

        const variant = variants[variantIdx];
        const $priceMonth = $column.find('.prices .price-month strong');
        const $priceMonthDel = $column.find('.prices .price-month del');
        const $priceForXMonths = $column.find('.price_for_x_months');

        // Price per month.
        const pricePerMonth = Math.round(variant.price / variantLength);
        $priceMonth.text(formatPrice(pricePerMonth));

        // Del price logic.
        const variantRegular = Math.round(variant.display_regular_price / variantLength);
        const isOnSale = variant.display_regular_price > variant.price;

        let showDel = false;
        let delPrice = variantRegular;
        if (showReferencePrice && showPricesPerMonth && variants[0]) {
            const oneMonthPrice = Math.round(variants[0].price);
            if (oneMonthPrice > pricePerMonth) {
                showDel = true;
                delPrice = oneMonthPrice;
            }
        }
        if (!showDel && showPromoPrices && isOnSale) {
            showDel = true;
        }
        $priceMonthDel.text(delPrice);
        showDel ? $priceMonthDel.show() : $priceMonthDel.hide();

        // Price for X months.
        if (showPricesPerMonth && actualVariantLength > 1) {
            const totalPrice = formatPrice(variant.price);
            const totalRegular = formatPrice(variant.display_regular_price);
            const variantOnSale = variant.display_regular_price > variant.price;

            if (showPromoPrices && variantOnSale) {
                $priceForXMonths.html(`<del>${totalRegular}</del> ${totalPrice} zł za ${actualVariantLength} mies.`);
            } else {
                $priceForXMonths.text(`${totalPrice} zł za ${actualVariantLength} mies.`);
            }
            $priceForXMonths.show();
        } else {
            $priceForXMonths.hide();
        }

        // Omnibus.
        $column.find('.omnibus').html(variant.omnibus_msg || '');

        // Payment description texts.
        updatePaymentDescriptions($column, variantIdx, actualVariantLength);

        // Savings (always based on subscription variants).
        updateSavings($column, variantIdx, actualVariantLength);

        // CTA link.
        updateCTALink($column, variantIdx);
    }

    function updatePaymentDescriptions($column, variantIdx, actualVariantLength) {
        const subVariants = $column.data('subscription-variants');
        const oneVariants = $column.data('onetime-variants');
        const monthsWord = getMonthsWord(actualVariantLength);

        // Subscription description.
        if (subVariants && subVariants[variantIdx]) {
            const subTotal = formatPrice(subVariants[variantIdx].price);
            $column.find('.subscription-desc').text(
                `Zapłacisz ${subTotal} zł, a co ${actualVariantLength} ${monthsWord} współpraca zostanie odnowiona automatycznie.`
            );
        }

        // Onetime description.
        if (oneVariants && oneVariants[variantIdx]) {
            const oneTotal = formatPrice(oneVariants[variantIdx].price);
            $column.find('.onetime-desc').text(
                `Zapłacisz ${oneTotal} zł jednorazowo.`
            );
        }
    }

    function updateSavings($column, variantIdx, actualVariantLength) {
        // Savings always based on subscription variants (excluding training plans).
        const subVariants = $column.data('subscription-variants');
        const $savings = $column.find('.package_savings');
        const prototype = $savings.data('prototype');

        if (!subVariants || !subVariants[0] || !subVariants[variantIdx]) {
            $savings.html('&nbsp;');
            return;
        }

        const savingsRaw = subVariants[0].price * actualVariantLength - subVariants[variantIdx].price;

        if (prototype && savingsRaw > 0) {
            $savings.text(prototype.replace('%s', formatPrice(savingsRaw)));
        } else {
            $savings.html('&nbsp;');
        }
    }

    function updateCTALink($column, variantIdx) {
        const $cta = $column.find('.offer-40__add-to-cart');
        if (!$cta.length) return;

        const variants = getActiveVariants($column);
        if (!variants || !variants[variantIdx]) return;

        const variationId = variants[variantIdx].variation_id;
        const trainingOn = $column.find('.training-toggle-input').is(':checked');

        $cta.attr('data-product_id', variationId);
        $cta.attr('data-training-add', trainingOn ? '1' : '0');

        if (trainingOn && trainingProductId) {
            // Will use AJAX, set href to # to prevent default navigation.
            $cta.attr('href', '#');
            $cta.attr('data-variation-id', variationId);
        } else {
            $cta.attr('href', `${cartUrl}?add-to-cart=${variationId}`);
            $cta.removeAttr('data-variation-id');
        }

        // Update CTA button text based on payment type.
        const paymentType = $column.find('input[name^="payment_type_"]:checked').val();
        const originalCta = $cta.data('original-cta') || $cta.text().trim();
        if (!$cta.data('original-cta')) {
            $cta.data('original-cta', $cta.text().trim());
        }

        if (paymentType === 'subscription') {
            $cta.text(originalCta.replace('Zamawiam', 'Zamawiam subskrypcję').replace('subskrypcję subskrypcję', 'subskrypcję'));
        } else {
            $cta.text(originalCta.replace('subskrypcję', '').replace('Zamawiam', 'Zamawiam').trim() || 'Zamawiam');
        }
    }

    function updatePropertyVisibility($column, variantIdx) {
        $column.find('.property').each(function () {
            const showOn = $(this).data('showOn');
            if (!showOn || !showOn.includes(variantIdx.toString())) {
                $(this).addClass('hidden');
            } else {
                $(this).removeClass('hidden');
            }
        });
    }

    function updateGlobalSavingsVisibility() {
        const $allSavings = $block.find('.package_savings');
        const hasAnySavings = $allSavings.filter(function () {
            return $(this).text().trim().length > 0 && $(this).html() !== '&nbsp;';
        }).length > 0;

        hasAnySavings ? $allSavings.show() : $allSavings.hide();
    }

    // ====== CTA CLICK HANDLER ======
    $block.on('click', '.offer-40__add-to-cart', function (e) {
        e.preventDefault();
        const $btn = $(this);
        // Guard re-entry with the loading class — never via prop('disabled'), because
        // jQuery skips delegated click handlers on disabled elements, so a second
        // rapid click would escape this handler and the browser would follow the
        // href (?add-to-cart=ID) as a full navigation.
        if ($btn.hasClass('xt_atc-loading')) return;
        const variationId = $btn.attr('data-variation-id') || $btn.attr('data-product_id');
        const trainingAdd = $btn.attr('data-training-add') === '1' && trainingProductId;

        startBtnLoader($btn);

        dnnzAjax('offer40_add_to_cart', {
            main_variation_id: variationId,
            training_product_id: trainingProductId,
            add_training: trainingAdd ? 1 : 0,
        }).then((response) => response.json()).then((response) => {
            if (response.data && response.data.redirect) {
                window.location.href = response.data.redirect;
            } else {
                window.location.href = cartUrl;
            }
        }).catch(() => {
            stopBtnLoader($btn);
        });
    });

    // ====== BUTTON LOADER (reuses XT Ajax Add To Cart styles) ======

    function startBtnLoader($btn) {
        $btn.data('original-html', $btn.html());

        const styles = window.getComputedStyle($btn[0]);
        $btn.css({ width: styles.width, height: styles.height });
        $btn.addClass('xt_atc-loading');

        const spinnerIcon = (window.XT_ATC && XT_ATC.spinnerIcon) ? XT_ATC.spinnerIcon : 'xt_icon-spinner2';
        const $wrap = $(`<span class="xt_atc-button-spinner-wrap"><span class="xt_atc-button-spinner ${spinnerIcon}"></span></span>`);
        $btn.html($wrap);

        setTimeout(() => { $wrap.addClass('xt_atc-button-spinner-ready'); }, 5);
    }

    function stopBtnLoader($btn) {
        $btn.html($btn.data('original-html'));
        $btn.removeClass('xt_atc-loading');
        $btn.css({ width: '', height: '' });
    }

    // ====== STICKY BEHAVIOR ======

    // Desktop: column-top sticks until training-plans section.
    let columnTopObservers = [];

    function updateColumnTopPosition() {
        if (window.innerWidth >= 1200) {
            $block.find('.offer-40__column-top').css('top', '');
            return;
        }

        const ds = $block.find('.offer-40__duration-selector')[0];
        const ps = $block.find('.offer-40__package-selector')[0];

        if (ps) {
            const psTop = parseFloat(window.getComputedStyle(ps).top) || 0;
            let psHeight = ps.offsetHeight;

            // Subtract collapsible elements (hidden when stuck).
            if (!ps.classList.contains('stuck')) {
                const heading = ps.querySelector('.package-select-heading');
                if (heading) {
                    const hs = window.getComputedStyle(heading);
                    psHeight -= heading.offsetHeight + parseFloat(hs.marginTop) + parseFloat(hs.marginBottom);
                }
            }

            const newTop = psTop + psHeight + 5;
            $block.find('.offer-40__column-top').css('top', `${newTop}px`);
        } else if (ds) {
            const dsTop = parseFloat(window.getComputedStyle(ds).top) || 0;
            let dsHeight = ds.offsetHeight;

            if (!ds.classList.contains('stuck')) {
                const dsHeading = ds.querySelector('.duration-select-heading');
                if (dsHeading) {
                    const dhs = window.getComputedStyle(dsHeading);
                    dsHeight -= dsHeading.offsetHeight + parseFloat(dhs.marginTop) + parseFloat(dhs.marginBottom);
                }
                const infoText = ds.querySelector('.offer-40__info-text');
                if (infoText) {
                    const its = window.getComputedStyle(infoText);
                    dsHeight -= infoText.offsetHeight + parseFloat(its.marginTop) + parseFloat(its.marginBottom);
                }
            }

            const newTopDs = dsTop + dsHeight + 5;
            $block.find('.offer-40__column-top').css('top', `${newTopDs}px`);
        }
    }

    function updateMobileColumnTopSticky() {
        if (window.innerWidth >= 1200) return;

        $block.find('.offer-40__column.active').each(function () {
            const $column = $(this);
            const $columnTop = $column.find('.offer-40__column-top');
            if (!$columnTop.length) return;

            const ctRect = $columnTop[0].getBoundingClientRect();
            const stickyTop = parseFloat($columnTop.css('top')) || 0;
            const $boundary = $columnTop.closest('.offer-40__sticky-boundary');

            // Column-top is stuck when its top equals its CSS top value.
            const isStuck = ctRect.top <= stickyTop + 1;

            if (isStuck) {
                if (!$columnTop.hasClass('is-sticky')) {
                    // Hide icons on INACTIVE columns instantly so they don't flash on package switch.
                    $block.find('.offer-40__column:not(.active) .offer-40__package-icons')
                        .css({ transition: 'none', maxHeight: 0, opacity: 0, margin: 0, padding: 0, overflow: 'hidden' });

                    $boundary.css('min-height', $boundary.outerHeight());
                    $columnTop.addClass('is-sticky');
                }
            } else {
                if ($columnTop.hasClass('is-sticky')) {
                    $columnTop.removeClass('is-sticky');
                    $boundary.css('min-height', '');

                    // Restore icons on all columns.
                    $block.find('.offer-40__package-icons').css({ transition: '', maxHeight: '', opacity: '', margin: '', padding: '', overflow: '' });
                }
            }
        });
    }

    function setupColumnTopObservers() {
        columnTopObservers.forEach((obs) => obs.disconnect());
        columnTopObservers = [];

        if (window.innerWidth < 1200) {
            // On mobile, scroll handler manages is-sticky — don't reset here.
            return;
        }

        $block.find('.offer-40__column').each(function () {
            const $columnTop = $(this).find('.offer-40__column-top');
            const $trainingPlans = $(this).find('.offer-40__training-plans');

            if ($trainingPlans.length && $columnTop.length) {
                const $boundary = $columnTop.closest('.offer-40__sticky-boundary');
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !$columnTop.hasClass('is-sticky')) {
                            // Lock boundary height so training-plans doesn't shift.
                            $boundary.css('min-height', $boundary.outerHeight());
                            $columnTop.addClass('is-sticky');
                        } else if (!entry.isIntersecting && $columnTop.hasClass('is-sticky')) {
                            $columnTop.removeClass('is-sticky');
                            $boundary.css('min-height', '');
                        }
                    });
                }, {
                    rootMargin: `-${$columnTop.outerHeight() + 1}px 0px 0px 0px`,
                    threshold: 0,
                });

                observer.observe($trainingPlans[0]);
                columnTopObservers.push(observer);
            }
        });
    }

    setupColumnTopObservers();

    let scrollRafPending = false;

    $(window).on('scroll', () => {
        if (!scrollRafPending) {
            scrollRafPending = true;
            requestAnimationFrame(() => {
                updateMobileColumnTopSticky();
                scrollRafPending = false;
            });
        }
    });

    // Mobile: duration selector sticky observer.
    let packageSelectorObserver = null;

    function updatePackageSelectorTop() {
        if (window.innerWidth >= 1200) return;
        const ds = $block.find('.offer-40__duration-selector')[0];
        const ps = $block.find('.offer-40__package-selector')[0];
        if (!ds || !ps) return;

        const dsTop = parseFloat(window.getComputedStyle(ds).top) || 0;
        let dsHeight = ds.offsetHeight;

        // Subtract collapsible elements (hidden when stuck).
        if (!ds.classList.contains('stuck')) {
            const heading = ds.querySelector('.duration-select-heading');
            if (heading) {
                const hs = window.getComputedStyle(heading);
                dsHeight -= heading.offsetHeight + parseFloat(hs.marginTop) + parseFloat(hs.marginBottom);
            }
            const infoText = ds.querySelector('.offer-40__info-text');
            if (infoText) {
                const its = window.getComputedStyle(infoText);
                dsHeight -= infoText.offsetHeight + parseFloat(its.marginTop) + parseFloat(its.marginBottom);
            }
        }

        const newTop = dsTop + dsHeight;
        ps.style.top = `${newTop}px`;

        initPackageSelectorObserver(ps, newTop);
    }

    // Spacers to prevent layout shift when sticky selectors collapse.
    const $dsSpacer = $('<div class="offer-40__stuck-spacer"></div>').insertAfter($block.find('.offer-40__duration-selector'));
    const $psSpacer = $('<div class="offer-40__stuck-spacer"></div>').insertAfter($block.find('.offer-40__package-selector'));

    function initPackageSelectorObserver(elem, topValue) {
        if (packageSelectorObserver) packageSelectorObserver.disconnect();

        const psSentinel = elem.previousElementSibling;
        if (!psSentinel || !psSentinel.classList.contains('offer-40__sticky-sentinel')) return;

        packageSelectorObserver = new IntersectionObserver((entries) => {
            for (let i = 0; i < entries.length; i++) {
                const shouldStick = !entries[i].isIntersecting;
                if (shouldStick && !elem.classList.contains('stuck')) {
                    const fullH = elem.offsetHeight;
                    elem.classList.add('stuck');
                    $psSpacer.height(fullH - elem.offsetHeight);
                } else if (!shouldStick && elem.classList.contains('stuck')) {
                    elem.classList.remove('stuck');
                    $psSpacer.height(0);
                }
            }
        }, {
            rootMargin: `-${Math.round(topValue) + 1}px 0px 0px 0px`,
            threshold: 0,
        });
        packageSelectorObserver.observe(psSentinel);
    }

    // Duration selector: use sentinel from Twig to detect sticky state.
    const durationElem = $block.find('.offer-40__duration-selector')[0];
    let durationObserver = null;

    function setupDurationObserver() {
        if (durationObserver) durationObserver.disconnect();
        durationObserver = null;

        if (!durationElem) return;

        if (window.innerWidth >= 1200) {
            durationElem.classList.remove('stuck');
            $dsSpacer.height(0);
            return;
        }

        const dsSentinel = durationElem.previousElementSibling;
        if (!dsSentinel || !dsSentinel.classList.contains('offer-40__sticky-sentinel')) return;

        durationObserver = new IntersectionObserver((entries) => {
            for (let i = 0; i < entries.length; i++) {
                const shouldStick = !entries[i].isIntersecting;
                if (shouldStick && !durationElem.classList.contains('stuck')) {
                    const fullH = durationElem.offsetHeight;
                    durationElem.classList.add('stuck');
                    $dsSpacer.height(fullH - durationElem.offsetHeight);
                } else if (!shouldStick && durationElem.classList.contains('stuck')) {
                    durationElem.classList.remove('stuck');
                    $dsSpacer.height(0);
                }
            }
        }, {
            rootMargin: `-${parseInt(window.getComputedStyle(durationElem).getPropertyValue('top')) + 1}px 0px 0px 0px`,
            threshold: 0,
        });
        durationObserver.observe(dsSentinel);
    }

    setupDurationObserver();

    if (durationElem) {
        $(durationElem).find('.duration-select-heading').on('transitionend', () => {
            updatePackageSelectorTop();
            updateColumnTopPosition();
        });
    }

    // Initial package selector position + observer.
    $(document).ready(() => {
        updatePackageSelectorTop();
        updateColumnTopPosition();
    });
    $(window).on('resize', () => {
        setupDurationObserver();
        updatePackageSelectorTop();
        updateColumnTopPosition();
        setupColumnTopObservers();
        // Clean up mobile sticky state on resize to desktop.
        if (window.innerWidth >= 1200) {
            $block.find('.offer-40__column-top').removeClass('is-sticky');
            $block.find('.offer-40__sticky-boundary').css('min-height', '');
            $dsSpacer.height(0);
            $psSpacer.height(0);
        }
    });

    // ====== HEIGHT EQUALIZATION ======
    function equalizeColumnHeights() {
        if (window.innerWidth < 1200) return;

        const sections = ['.subheading', '.prices', '.offer-40__column-benefits', '.offer-40__training-plans', '.offer-40__payment-type'];
        sections.forEach((selector) => {
            const $elements = $block.find(`.offer-40__column ${selector}`);
            $elements.css('min-height', '');
            let maxH = 0;
            $elements.each(function () {
                maxH = Math.max(maxH, $(this).innerHeight());
            });
            if (maxH > 0) {
                $elements.css('min-height', maxH);
            }
        });
    }

    $(document).ready(equalizeColumnHeights);
    $(window).on('resize', equalizeColumnHeights);

    // ====== TOOLTIP & MODAL ======

    $('body').on('click', (e) => {
        if ($(e.target).parents().hasClass('property')
            || $(e.target).hasClass('property')
            || $(e.target).parents().hasClass('property_group')
            || $(e.target).hasClass('property_group')
            || $(e.target).parents().hasClass('offer-40__training-plans')
            || $(e.target).hasClass('offer-40__training-plans')
            || $(e.target).hasClass('tooltip-open')
            || $(e.target).parents().hasClass('tooltip-open')) {
            e.stopPropagation();
            return;
        }
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
    });

    $(document).on('keydown', (event) => {
        if (event.key === 'Escape') {
            closeModal();
        }
    });

    $('#offer-30-video-modal .modal-close').on('click', closeModal);

    $('#offer-30-video-modal .modal-wrapper').on('click', () => {
        closeModal();
    });

    $('#offer-30-video-modal .modal').on('click', (e) => {
        e.stopPropagation();
    });

    function closeModal() {
        const video = $('#offer-30-video-modal video')[0];
        if (video) video.pause();
        $('#offer-30-video-modal').fadeOut(300);
        $('body').css('overflow', 'auto');
    }

    $block.find('.property, .property-group-heading, .offer-40__training-plans .tooltip').on('click', function (e) {
        openTooltip($(this).find('.tooltip').length ? $(this).find('.tooltip') : $(this), e);
    });

    if (window.innerWidth > 992) {
        $block.find('.property, .property-group-heading').on('mouseover', function (e) {
            openTooltip($(this).find('.tooltip'), e);
        });

        $block.find('.offer-40__training-plans .training-plans-header').on('mouseover', function (e) {
            openTooltip($(this).find('.tooltip'), e);
        });
    }

    $block.find('.property, .property-group-heading').on('mouseout', (event) => {
        const related = event.relatedTarget;
        if ($(related).hasClass('tooltip-open') || $(related).parents().hasClass('tooltip-open')) {
            return;
        }
        $('.tooltip').removeClass('open');
        $('.tooltip-open').remove();
    });

    $block.find('.offer-40__training-plans .training-plans-header').on('mouseout', (event) => {
        const related = event.relatedTarget;
        if ($(related).hasClass('tooltip-open') || $(related).parents().hasClass('tooltip-open')) {
            return;
        }
        $('.tooltip').removeClass('open');
        $('.tooltip-open').remove();
    });

    function openTooltip($tt, event) {
        if (!$tt.length || !$tt.hasClass('tooltip')) return;

        if (event.type === 'click' && $(event.target).hasClass('play-icon') && $tt.hasClass('open')) {
            $('.tooltip-video').trigger('click');
            return;
        }

        if ($tt.hasClass('open')) return;
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
        $tt.addClass('open');

        const tooltipContent = $tt.data('tooltip-content');
        const tooltipVideo = $tt.data('video');
        const $tooltip = $(tooltipContent);
        $tt.append($tooltip);

        $tooltip.find('.tooltip-video').on('click', () => {
            $('#offer-30-video-modal video').attr('src', tooltipVideo).attr('controls', 'controls');
            $('#offer-30-video-modal video')[0].play();
            $('#offer-30-video-modal').fadeIn(300);
            $('body').css('overflow', 'hidden');
            $('.tooltip-open').remove();
            $tt.removeClass('open');
        });
    }

})(jQuery);
